import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import config from '../config/seo.json';
import seoHelpers from '../config/seo';

const { getPageSeo } = seoHelpers;

const SEO = () => {
  const { pathname } = useLocation();
  const seo = getPageSeo(pathname);
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="robots" content={seo.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={config.siteName} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={config.siteName + ' logo'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.canonical} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:image:alt" content={config.siteName + ' logo'} />
    </Helmet>
  );
};

export default SEO;
